import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';

import { IntroRoutingModule } from './intro-routing.module';
import { BeginAdmComponent } from './begin-adm/begin-adm.component';
import { BeginComponent } from './begin/begin.component';

import { CardModule } from 'primeng/card';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ResourcesModule } from '../resources/resources.module';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';
import { DatePickerModule } from 'primeng/datepicker';
import { RadioButtonModule } from 'primeng/radiobutton';



@NgModule({
  declarations: [BeginAdmComponent, BeginComponent],
  imports: [
    CommonModule,
    IntroRoutingModule,
    ResourcesModule,
    FormsModule, ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    CardModule,
    NgApexchartsModule,
    ToastModule,
    DialogModule,
    ConfirmDialogModule,
    CheckboxModule,
    DividerModule,
    CardModule,
    FieldsetModule,
    DatePickerModule,
    RadioButtonModule,
    SelectModule
  ]
})
export class IntroModule { }
